import { mat4 } from "pex-math";

function createDrawIconsCmd(ctx) {
  const drawIconsCmd = {
    name: "drawRegularCmd",
    pipeline: ctx.pipeline({
      vert: /*glsl*/ `
      attribute vec3 aPosition;
      attribute vec2 aTexCoord;
      attribute vec3 aOffset;
      attribute vec4 aInstanceUv;
        
      uniform mat4 uProjectionMatrix;
      uniform mat4 uViewMatrix;
      uniform mat4 uModelMatrix;

      varying vec2 vTexCoord;

      void main () {   
        vTexCoord = aInstanceUv.xy + aInstanceUv.zw * aTexCoord;    
        vec4 positionWorld = uModelMatrix * vec4(aPosition + aOffset, 1.0);
        gl_Position = uProjectionMatrix * uViewMatrix * positionWorld;            
      }
      `,
      frag: /*glsl*/ `
      precision highp float;           
      varying vec2 vTexCoord;        
      uniform sampler2D uAxisIconsTexture;
      uniform float uOpacity;

      //   
      void main () {
        
        gl_FragData[0] = texture2D(uAxisIconsTexture, vTexCoord);
        // gl_FragData[0] += vec4(vTexCoord, 0.0, 1.0);
        gl_FragData[0].a = gl_FragData[0].a * clamp(uOpacity, 0.0, 1.0);          
      }
      `,
      depthTest: true,
      depthWrite: true,
      blend: true,
      blendSrcRGBFactor: ctx.BlendFactor.SrcAlpha,
      blendSrcAlphaFactor: ctx.BlendFactor.One,
      blendDstRGBFactor: ctx.BlendFactor.OneMinusSrcAlpha,
      blendDstAlphaFactor: ctx.BlendFactor.One,
    }),
    attributes: {
      aPosition: null,
      aTexCoord: null,
      aOffset: { buffer: null, divisor: 1 },
      aInstanceUv: { buffer: null, divisor: 1 },
    },
    indices: null,
  };

  const defaultModelMatrix = mat4.create();

  return function drawIcons({ ctx, camera, mesh, axisIconsTexture, opacity }) {
    drawIconsCmd.attributes.aPosition = mesh.positions.buffer;
    drawIconsCmd.attributes.aTexCoord = mesh.uvs.buffer;
    drawIconsCmd.attributes.aOffset.buffer = mesh.offsets.buffer;
    drawIconsCmd.attributes.aInstanceUv.buffer = mesh.instanceUvs.buffer;
    drawIconsCmd.indices = mesh.indices.buffer;
    drawIconsCmd.instances = mesh.instances;

    if (!axisIconsTexture.width) return;

    ctx.submit(drawIconsCmd, {
      uniforms: {
        uBaseColor: [1, 1, 1, 1],
        uProjectionMatrix: camera.projectionMatrix,
        uViewMatrix: camera.viewMatrix,
        uAxisIconsTexture: axisIconsTexture,
        uModelMatrix: mesh.modelMatrix || defaultModelMatrix,
        uOpacity: opacity,
      },
    });
  };
}

export default createDrawIconsCmd;
